import styled from "styled-components";

export const ShopExtPageContainer = styled.div``;
